import { config } from "../../config"
import { LibraryImport, Profile } from "./data-types"


export const getProfile = async (publicId: string, token?: string): Promise<Profile> => {
    const authHeaders: {[key: string]: string} = {}
    if (token) {
        authHeaders['token'] = token!
    }

    const res = await fetch(`${config.api.urlV1}/user/profile/?user_id=${publicId}`, {
        headers: {
            'Content-type': 'application/json',
            ...authHeaders,
        },
        method: 'GET',
    })

    if (res.status !== 200) {
        console.log('Error getting profile', { status: res.status, text: await res.text() })
        throw new Error('response')
    }

    const json = await res.json()

    console.log(json.data)

    return json.data
}

export const getLibraryImports = async (token: string): Promise<LibraryImport[]> => {
    const res = await fetch(`${config.api.urlV1}/library_import/list/`, {
        headers: {
            'Content-type': 'application/json',
            token,
        },
        method: 'GET',
    })

    if (res.status !== 200) {
        console.log('Error getting imports list', { status: res.status, text: await res.text() })
        throw new Error('response')
    }

    const json = await res.json()

    console.log(json.data)

    return json.data
}
